import { Link } from "react-router-dom";
import { components, getLevel } from "../data/competencyData";
import { growthActions } from "../data/studentData";

// Diagnostika natijasi bo'yicha eng zaif komponentlarga shaxsiy tavsiyalar
function GrowthPlan({ scores, count = 2 }) {
    const weakest = [...components]
        .sort((a, b) => scores[a.id] - scores[b.id])
        .slice(0, count);

    return (
        <div style={{ background: "#fff8e6", border: "1px solid #ffe2a1", borderRadius: 12, padding: 24 }}>
            <h4 style={{ marginBottom: 6 }}>Shaxsiy rivojlanish rejangiz</h4>
            <p style={{ color: "#666", marginBottom: 20 }}>
                Natijangiz bo'yicha eng ko'p e'tibor talab qiladigan komponentlar va ularni oshirish uchun aniq qadamlar:
            </p>
            <div className="row gutter-y-20">
                {weakest.map((c) => (
                    <div className={count > 1 ? "col-lg-6" : "col-12"} key={c.id}>
                        <div className="d-flex align-items-center" style={{ gap: 8, marginBottom: 10 }}>
                            <i className={c.icon} style={{ color: "#ffb606" }}></i>
                            <strong>{c.title}</strong>
                            <span style={{ color: getLevel(scores[c.id]).color, fontWeight: 600 }}>{scores[c.id]}%</span>
                        </div>
                        <ol style={{ paddingLeft: 20, margin: 0 }}>
                            {growthActions[c.id].map((a, i) => (
                                <li key={i} style={{ marginBottom: 8, color: "#444" }}>
                                    {a.text}{" "}
                                    <Link to={a.path} style={{ color: "#ffb606", fontWeight: 600, whiteSpace: "nowrap" }}>{a.link} →</Link>
                                </li>
                            ))}
                        </ol>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default GrowthPlan;
